import { Component, inject, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CenterService } from 'src/app/private/services/center.service';
import { CreateCenterComponent } from "../create-center/create-center.component";
import { DeleteCenterComponent } from "../delete-center/delete-center.component";


@Component({
  selector: 'app-center-details',
  imports: [SharedModule, CreateCenterComponent, DeleteCenterComponent],
  templateUrl: './center-details.component.html',
  styleUrl: './center-details.component.scss'
})


export class CenterComponent implements OnInit {
  @Input() clientId!: string;
  centers: any[] = [];
  totalRecords = 0;
  rows = 10;
  loading = true;

  displayAddModal = false;
  showEditCenter = false;
  showDeleteCenter = false;
  centerDataToEdit: any = null;

  addForm: FormGroup;
  selectedCenters: any[] = [];

  centerActionItem: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Center',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.showEditCenter = true;
          }
        },
        {
          label: 'Delete Center',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteCenter = true;
          }
        }
      ]
    }
  ];

  constructor(
    private centerService: CenterService,
    private fb: FormBuilder
  ) {
    this.addForm = this.fb.group({
      center_name: ['', Validators.required],
      client_id: ['', Validators.required],
      bot_client_id: ['', Validators.required],
      status: [''],
    });
  }

  ngOnInit(): void { }

  openAddModal() {
    this.addForm.reset();
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
    this.addForm.reset();
  }

  setCenterData(data: any) {
    this.centerDataToEdit = data;
  }

  loadCenters(event: any): void {
    this.loading = true;
    const payload = {
      "page": 0,
      "limit": 100,
      "where": {
        "client_id": this.clientId,
      },
      "order": {
        "col": "\"center\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.centerService.getAllCenterWithCount(payload).subscribe({
      next: (data) => {
        this.centers = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading centers:', err);
        this.loading = false;
      }
    });
  }

  reload() {
    this.loadCenters({ first: 0, rows: this.rows });
  }
}
